import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ChevronRight, Home } from "lucide-react";

export function Breadcrumbs({ items = [] }) {
    const { t } = useTranslation();
    // items: [{ to, label }] — last item is current page (no link)
    return (
        <nav aria-label={t("common.breadcrumb")} data-testid="breadcrumb" className="text-sm">
            <ol className="flex items-center flex-wrap gap-1 text-[color:var(--text-soft)]">
                <li>
                    <Link
                        to="/"
                        className="inline-flex items-center gap-1 hover:text-[color:var(--brand-navy)]"
                    >
                        <Home className="h-3.5 w-3.5" />
                        <span className="sr-only">{t("common.home")}</span>
                    </Link>
                </li>
                {items.map((item, idx) => {
                    const isLast = idx === items.length - 1;
                    const key = item.to || `${idx}-${item.label}`;
                    return (
                        <li key={key} className="flex items-center gap-1">
                            <ChevronRight className="h-3.5 w-3.5" />
                            {isLast || !item.to ? (
                                <span className="text-[color:var(--brand-navy)] font-medium">
                                    {item.label}
                                </span>
                            ) : (
                                <Link
                                    to={item.to}
                                    className="hover:text-[color:var(--brand-navy)]"
                                >
                                    {item.label}
                                </Link>
                            )}
                        </li>
                    );
                })}
            </ol>
        </nav>
    );
}
